import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { IPendingRelationMutation } from '../../api/types/relation_mutation'
import { logout, refreshSession } from '../actions/constants'

export interface IRelationMutationsState {
  pendingRelationMutations?: IPendingRelationMutation
}

const initialState: IRelationMutationsState = {
  pendingRelationMutations: undefined
}

export const relationMutationsSlice = createSlice({
  name: 'relationMutations',
  initialState,
  reducers: {
    setPendingRelationMutations: (state, action: PayloadAction<IPendingRelationMutation>) => {
      state.pendingRelationMutations = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState)
      .addCase(refreshSession, () => initialState)
  }
})

export const {
  setPendingRelationMutations
} = relationMutationsSlice.actions

export default relationMutationsSlice.reducer
